/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_TitleInputs */

const en_st_wl_title = /** @type {(inputs: St_Wl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Studio waitlist`)
};

const id_st_wl_title = /** @type {(inputs: St_Wl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar waitlist Studio`)
};

/**
* | output |
* | --- |
* | "Join the Studio waitlist" |
*
* @param {St_Wl_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_title = /** @type {((inputs?: St_Wl_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_title(inputs)
	return en_st_wl_title(inputs)
});